// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  text-align: center;
  margin-top: 50px;
  font-family: Arial, sans-serif;
}

.scene {
  width: 120px;
  height: 120px;
  margin: 40px auto;
  perspective: 600px;
}

.cube {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
  transform: rotateX(0deg) rotateY(0deg);
  transition: transform 5s;
}

/* Faces */
/* .face {
  position: absolute;
  width: 120px;
  height: 120px;
  background: #1e90ff;
  border: 2px solid #fff;
  color: white;
  font-size: 40px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
} */

.face {
  
  position: absolute;
  width: 120px;
  height: 120px;

  /* Wood texture using gradients */
  background: linear-gradient(
      90deg,
      #8b5a2b 0%,
      #a0522d 20%,
      #8b5a2b 40%,
      #a0522d 60%,
      #8b5a2b 80%,
      #a0522d 100%
  );

  border: 2px solid #5c3a1a;
  color: #fff8dc;

  font-size: 40px;
  font-weight: bold;

  display: flex;
  align-items: center;
  justify-content: center;

  /* Depth + realism */
  box-shadow:
    inset 0 0 10px rgba(0,0,0,0.4),
    0 5px 10px rgba(0,0,0,0.3);

  border-radius: 8px;
}

/* Position each face */
.front  { transform: rotateY(0deg) translateZ(60px); }
.back   { transform: rotateY(180deg) translateZ(60px); }
.right  { transform: rotateY(90deg) translateZ(60px); }
.left   { transform: rotateY(-90deg) translateZ(60px); }
.top    { transform: rotateX(90deg) translateZ(60px); }
.bottom { transform: rotateX(-90deg) translateZ(60px); }

/* Show faces */
.show-1 { transform: rotateX(0deg) rotateY(0deg); }
.show-2 { transform: rotateX(90deg) rotateY(0deg); }
.show-3 { transform: rotateY(-90deg); }
.show-4 { transform: rotateY(90deg); }
.show-5 { transform: rotateX(-90deg); }
.show-6 { transform: rotateY(180deg); }

/* Rolling animation */
.rolling .cube {
  animation: roll 1s ease;
}

.face .front span {
  width :200px;
}
@keyframes roll {
  0%   { transform: rotateX(0) rotateY(0); }
  50%  { transform: rotateX(180deg) rotateY(180deg); }
  100% { transform: rotateX(360deg) rotateY(360deg); }
}

button {
  padding: 10px 20px;
  font-size: 18px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/dice/dice3d.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA,UAAU;AACV;;;;;;;;;;;;GAYG;;AAEH;;EAEE,kBAAkB;EAClB,YAAY;EACZ,aAAa;;EAEb,iCAAiC;EACjC;;;;;;;;GAQC;;EAED,yBAAyB;EACzB,cAAc;;EAEd,eAAe;EACf,iBAAiB;;EAEjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,oBAAoB;EACpB;;8BAE4B;;EAE5B,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB,UAAU,yCAAyC,EAAE;AACrD,UAAU,2CAA2C,EAAE;AACvD,UAAU,0CAA0C,EAAE;AACtD,UAAU,2CAA2C,EAAE;AACvD,UAAU,0CAA0C,EAAE;AACtD,UAAU,2CAA2C,EAAE;;AAEvD,eAAe;AACf,UAAU,sCAAsC,EAAE;AAClD,UAAU,uCAAuC,EAAE;AACnD,UAAU,0BAA0B,EAAE;AACtC,UAAU,yBAAyB,EAAE;AACrC,UAAU,0BAA0B,EAAE;AACtC,UAAU,0BAA0B,EAAE;;AAEtC,sBAAsB;AACtB;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;AACA;EACE,OAAO,gCAAgC,EAAE;EACzC,OAAO,0CAA0C,EAAE;EACnD,OAAO,0CAA0C,EAAE;AACrD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB","sourcesContent":[".container {\n  text-align: center;\n  margin-top: 50px;\n  font-family: Arial, sans-serif;\n}\n\n.scene {\n  width: 120px;\n  height: 120px;\n  margin: 40px auto;\n  perspective: 600px;\n}\n\n.cube {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transform-style: preserve-3d;\n  transform: rotateX(0deg) rotateY(0deg);\n  transition: transform 5s;\n}\n\n/* Faces */\n/* .face {\n  position: absolute;\n  width: 120px;\n  height: 120px;\n  background: #1e90ff;\n  border: 2px solid #fff;\n  color: white;\n  font-size: 40px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n} */\n\n.face {\n  \n  position: absolute;\n  width: 120px;\n  height: 120px;\n\n  /* Wood texture using gradients */\n  background: linear-gradient(\n      90deg,\n      #8b5a2b 0%,\n      #a0522d 20%,\n      #8b5a2b 40%,\n      #a0522d 60%,\n      #8b5a2b 80%,\n      #a0522d 100%\n  );\n\n  border: 2px solid #5c3a1a;\n  color: #fff8dc;\n\n  font-size: 40px;\n  font-weight: bold;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  /* Depth + realism */\n  box-shadow:\n    inset 0 0 10px rgba(0,0,0,0.4),\n    0 5px 10px rgba(0,0,0,0.3);\n\n  border-radius: 8px;\n}\n\n/* Position each face */\n.front  { transform: rotateY(0deg) translateZ(60px); }\n.back   { transform: rotateY(180deg) translateZ(60px); }\n.right  { transform: rotateY(90deg) translateZ(60px); }\n.left   { transform: rotateY(-90deg) translateZ(60px); }\n.top    { transform: rotateX(90deg) translateZ(60px); }\n.bottom { transform: rotateX(-90deg) translateZ(60px); }\n\n/* Show faces */\n.show-1 { transform: rotateX(0deg) rotateY(0deg); }\n.show-2 { transform: rotateX(90deg) rotateY(0deg); }\n.show-3 { transform: rotateY(-90deg); }\n.show-4 { transform: rotateY(90deg); }\n.show-5 { transform: rotateX(-90deg); }\n.show-6 { transform: rotateY(180deg); }\n\n/* Rolling animation */\n.rolling .cube {\n  animation: roll 1s ease;\n}\n\n.face .front span {\n  width :200px;\n}\n@keyframes roll {\n  0%   { transform: rotateX(0) rotateY(0); }\n  50%  { transform: rotateX(180deg) rotateY(180deg); }\n  100% { transform: rotateX(360deg) rotateY(360deg); }\n}\n\nbutton {\n  padding: 10px 20px;\n  font-size: 18px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
